<template>
  <request-page></request-page>
</template>
<script>

import RequestPage from '../components/request/index.vue';

export default { components: { RequestPage } };

</script>
